export const selectCurrentSubmission = (state) => state.quiz.currentSubmission 
export const selectWeeks = (state) => state.quiz.weeks
export const selectCurrentWeek = (state) => state.quiz.currentWeek
export const selectQuizDetails = (state) => state.quiz.quizDetails
export const selectQuizStore = (state) => state.quiz;
export const selectQuizStoreIsLoading = (state) => state.quiz.isLoading;
export const selectCurrentQuestionNo = (state) => state.quiz.currentQuestionNo;
export const selectIsLoading = (state) => state.quiz.isLoading;
export const selectCurrentStartTime = (state) => state.quiz.startTime;